<template>
  <el-row type="flex" justify="end" class="sort-blocks">
    <i
      :class="[
        { 'el-icon-top': order, 'el-icon-upload2': !order },
        { disabled: !index && order },
      ]"
      @click="onSort('up')"
    />
    <i
      v-if="order"
      :class="['el-icon-bottom', { disabled: order === 1 }]"
      @click="onSort('down')"
    />
    <i v-if="order" class="el-icon-close" @click="onSort('remove')" />
  </el-row>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'SortBtns',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    order: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onSort(action) {
      Bids.changeSort(this.id, action)
        .then(() => this.$emit('fetch'))
        .catch(err => this.errHandler(err))
    },
  },
}
</script>

<style lang="sass">
#bid-info
  padding-bottom: 10px
  min-height: 150px
  .sort-blocks i
    font-size: 24px
    font-weight: bold
    margin-left: 15px
    cursor: pointer
    color: #5daf34
    &.disabled
      color: rgba(93, 175, 52, 0.3)
      cursor: auto
    &.el-icon-bottom
     color: #ff0000
     &.disabled
       color: rgba(255, 0, 0, 0.3)
    &.el-icon-close
      color: #666
</style>
